import AccountExpiredPage from './AccountExpiredPage';
import { AccountExpiredPageProps, AccountExpiredPageValueProps } from './types';

export type { AccountExpiredPageProps, AccountExpiredPageValueProps };
export default AccountExpiredPage;
